import { useParams, Link } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LocationListTable from '@/app/location/ListTable';
import LoadingPage from '@/components/common/LoadingPage';
import RegionTaxList from './view/RegionTaxList';

import { useRegion } from '@/data/region';
import { useLocations } from '@/data/location';
import { useTaxes } from '@/data/tax';

const ViewPage = () => {
  const params = useParams();
  const region = useRegion(params.regionId);

  return (
    <>
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/region">Regions</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{region.data.name}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            {region.data.name} Region
          </CardTitle>
          <CardDescription>
            Locations in this region. A location is a specific place where the
            lesson or experience will take place. Tenants can add and delete
            their own locations and they will show up here.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="mb-8">
            <RegionTaxList regionTaxes={region.data.taxes} />
          </div>
          <h3 className="text-lg font-bold mb-6 flex justify-between items-center">
            Region Locations
          </h3>
          <LocationListTable />
        </CardContent>
      </Card>
    </>
  );
};

const ViewPageLoader = () => {
  const params = useParams();
  const region = useRegion(params.regionId);
  const locations = useLocations(params.regionId);
  const taxes = useTaxes();

  if (region.isLoading && !region.data) {
    return <LoadingPage />;
  }
  if (locations.isLoading && !locations.data) {
    return <LoadingPage />;
  }
  if (taxes.isLoading && !taxes.data) {
    return <LoadingPage />;
  }

  return <ViewPage />;
};

export default ViewPageLoader;
